import { Button, Card, Grid } from '@material-ui/core';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import moment from 'moment';
import { HistorySharp } from '@material-ui/icons';
import { Redirect } from "react-router-dom";
import TableGeneric from '../../compartidos/abms/TableGeneric';
import { ModificarAfiliadoRecupero } from './ModificarAfiliadoRecupero';

export const ListaAfiliadosRecupero = (props) => {

    const { afiliadosRecupero } = useSelector((state) => state.autorizaciones);
    const [openModalCambio, setOpenModalCambio] = useState(false);
    const [infoAfiliado, setInfoAfiliado] = useState("");
    const [redirect, setRedirect] = useState(false);

    const reinicio = () => {
        setRedirect(true)
    }

    console.log(afiliadosRecupero)

    return (
        <React.Fragment>
            {redirect && (
                <Redirect
                    to={{
                        pathname: '/autorizaciones/afiliadosRecupero',
                        state: {
                            from: '/autorizaciones/afiliadosRecupero',
                        },
                    }}
                />
            )}
            {openModalCambio && (
                <ModificarAfiliadoRecupero
                    open={openModalCambio}
                    closeModalHandler={() => {
                        setOpenModalCambio(false);
                    }}
                    infoAfiliado={infoAfiliado}

                />
            )}
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item xs={12} md={8} style={{ paddingLeft: 0, marginTop: 20 }}>
                    <Card>
                        <TableGeneric
                            data={afiliadosRecupero}
                            sizeTableCells={["8", "25%", "25%", "15%", "15%", "10%", "10%"]}
                            columns={[
                                {
                                    label: "",
                                    id: "",
                                    sort: false,
                                    customBody: (item) => (
                                        <HistorySharp
                                            onClick={() => {
                                                setOpenModalCambio(true);
                                                setInfoAfiliado(item);
                                                //setDescripcion(`${item?.codNom} - ${item?.desNom}`);
                                            }}
                                        />
                                    ),
                                },
                                // {
                                //     label: "Id Solicitud",
                                //     id: "idSolicitud",
                                //     sort: true
                                // },
                                {
                                    label: "Id Afiliado",
                                    id: "idAfiliado",
                                    sort: true
                                },
                                {
                                    label: "Apellido y Nombre",
                                    id: "apellidoNombre",
                                    sort: true
                                },
                                {
                                    label: "Fecha Ingreso",
                                    id: "fechaIngreso",
                                    customBody: (item) =>
                                        moment(item.fechaIngreso).format("DD/MM/YYYY"),

                                },
                                {
                                    label: "Fecha Egreso",
                                    id: "fechaEgreso",
                                    customBody: (item) => {
                                        const fechaEgreso = item.fechaEgreso;
                                        return fechaEgreso ? moment(fechaEgreso).format("DD/MM/YYYY") : "Sin Egreso";
                                    },
                                },

                            ]}
                        />
                        {/* {openModalInfo && (
              <ModalHistoricoTrackingAbm
                open={openModalInfo}
                onClose={() => setOpenModalInfo(false)}
                idClave={idClave}
                descripcion={descripcion}
                tipoTrackingId={TIPO_TRACKING_ABM.NOMENCLADOR_NACIONAL}
              />
            )} */}
                    </Card>
                </Grid>
                <Grid item xs={12} md={8} style={{ paddingLeft: 0, marginTop: 20 }}>
                    <div
                        style={{
                            margin: '1rem 0',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex',
                        }}
                    >
                        <Button variant="contained" color="primary" onClick={reinicio}>
                            Reiniciar buscador
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}
